export default {
    add_stage: "Bosqich qo'shing",
    additional: "Qo'shimcha",
    alternative: "Muqobil",
    amount_completed: "Bajarilgan miqdor",
    apply_plan_treatment: "Davolash rejasini qo'llash",
    apply_to_which_teeth: "Qaysi tishlarga murojaat qilish kerak",
    apply_treatment_stage_template: "Davolash bosqichi shablonini qo'llang",
    are_you_sure_you_want_to_cancel_plan: "Rejani bekor qilmoqchimisiz?",
    by_stages: "Bosqichlar bo'yicha",
    calls_planning: "Qo‘ng‘iroqlarni rejalashtirish",
    cancel_plan_treatment: "Davolash rejasini bekor qiling",
    changes_in_current_stage_were_not_saved: "Joriy bosqichdagi o'zgarishlar saqlanmaydi",
    choose_criterias_for_fill: "To'ldirish uchun kerakli mezonlarni tanlang",
    collapse: "Yiqilish",
    comments: "Izohlar",
    completed_sum: "Bajarilgan summa",
    complex_doctor: "Kompleks shifokor",
    'DD.MM.YYYY': "DD.MM.YYYY",
    deadline2: "Topshirish muddati; tugatish muddati",
    delete_stage: "Bosqichni o'chirish",
    document_header: "Davolash rejasida shlyapa",
    editing_is_blocked_now_user_is_working: "Vaqtinchalik tahrirlash imkonsiz: {user} hozirda ishlamoqda",
    expand: "Kengaytirish",
    grouped: "Guruhlangan",
    grouped_by_services: "Xizmatlar bo'yicha guruhlangan",
    grouped_by_teeth: "Tishlar bo'yicha guruhlangan",
    hide_tooth_formula: "Tish formulasini yashirish",
    kits_and_materials: "To'plamlar va materiallar",
    last_update: "Oxirgi tahrirlangan",
    left: "Chapga",
    level_description: "Bosqich tavsifi",
    main_complaints: "Asosiy shikoyatlar",
    not_signed: "Imzalanmagan",
    notification_date: "Bildirishnoma sanasi",
    plan: "Reja",
    plan_status: "Reja holati",
    plan_treatment_application: "Davolash rejasini qo'llash",
    plan_treatment_status: "Davolash rejasi holati",
    plan_type: "Reja turi",
    planned_sum: "Rejalanmagan summa",
    previous_visits: "O'tgan tashriflar",
    quantity: "Miqdori",
    recommended: "Tavsiya etilgan",
    reset_all: "Hammasini tiklang",
    route_list: "Yo'nalish varaqasi",
    save_as_plan_stage_template: "Davolanish bosqichi shabloni sifatida saqlang",
    select_a_doctor_2: "Shifokorni tanlang",
    select_all: "Hammasini tanlang",
    select_field: "Yo'nalishni tanlang",
    select_number: "Raqamni tanlang",
    select_plan: "Rejani tanlang",
    select_type: "Turni tanlang",
    services_selected: "Xizmatlar tanlandi",
    show_tooth_formula: "Tish formulasini ko'rsating",
    sign_without_upload: "Yuklab olmasdan ro'yxatdan o'ting",
    signed_at: "Imzolangan",
    stage_deletion_confirm_text: "Bosqich tiklanish imkoniyatisiz o'chiriladi. Saqlanmagan barcha o'zgarishlar yo'qoladi.",
    stage_doctor: "Bosqich shifokori",
    stage_title: "Sahna nomi",
    stages_discount: "Bosqichma-bosqich chegirma",
    total_sum: "Jami summa",
    treatment_plan_amount: "Davolash rejasining miqdori",
    treatment_plan_doctor: "Davolash rejasining shifokori",
    treatment_template_application: "Davolash shablonini qo'llash",
    which_fields_to_fill: "Qaysi maydonlarni to'ldirish kerak",
    write_patient_complaints: "Bemorning shikoyatlarini yozing",
    write_stage_description: "Bosqich tavsifini yozing"
}
